// extracted by mini-css-extract-plugin
export default {"icon":"ItemIcon_icon__Nsbpg"};